import React, { useState, useEffect } from "react";
import { Formik, Field, Form } from "formik";
import {
  InputGroup,
  Label,
  SubmitBtn,
  SideCancelBtn,
  Wrapper,
  ScrollableContent,
  ActionSection,
  ModalHeader,
  ModalRow,
  ModalSectionTitle,
  ModalSection,
  ModalRowValue,
  EditButton,
} from "../../Styles/InputStyles";
import { MdClose } from "react-icons/md";
import tw from "tailwind-styled-components";
import * as Yup from "yup";
import MenuItem from "@mui/material/MenuItem";
import Select from "@mui/material/Select";
import "react-datepicker/dist/react-datepicker.css";
import moment from "moment";
import DropZone from "../../Notice/Dropzone";
import ModalProfileHeader from "../../Common/ModalProfileHeader";
import { capitalizeFirstLetter } from "../../../helpers";

const documentSchema = Yup.object().shape({
  documentType: Yup.string().required("Document type is required"),
  file: Yup.mixed().required("File is required"),
});

const documentTypeOptions = [
  { label: "Rent Agreement", value: 5 },
  // { label: "PAN Card", value: 3 },
  // { label: "Aadhaar Front", value: 1 },
  // { label: "Aadhaar Back", value: 2 },
  { label: "Police Verification", value: 6 },
  { label: "Cancelled Cheque", value: 13 },
];

const ViewLeaseDetails = ({
  leaseData,
  handleClose,
  selectedData,
  documentData,
  setShowUploadForm,
  showUploadForm,
  addDocumentLoading,
  addDocumentMutate,
  setShowEditLeaseModel,
  setShowManagePaymentModel,
  setLeaseData,
  fromPage
}) => {
  const hasLeaseDetails = true;
  const hasLeaseDocs = documentData?.data?.docs ||
    (leaseData?.docs && Array.isArray(leaseData.docs) && leaseData.docs.length > 0)
    ;

  const initialValues =
  {
    landlordName: leaseData.leaseDetails.landlordName || "",
    mobile: leaseData.leaseDetails.landlordMobile || "",
    rentPayable: leaseData.leaseDetails.rent || "",
    securityDeposit: leaseData.leaseDetails.security || "",
    agreementStartDate: leaseData.leaseDetails.startDate
      ? new Date(leaseData.leaseDetails.startDate)
      : null,
    agreementEndDate: leaseData.leaseDetails.endDate
      ? new Date(leaseData.leaseDetails.endDate)
      : null,
    noticePeriod: leaseData.leaseDetails.notice || "",
  };

  const initialDocumentValues = {
    documentType: "",
    file: null,
  };

  const [height, setHeight] = useState(window.innerHeight);

  useEffect(() => {
    const handleResize = () => {
      setHeight(window.innerHeight);
    };

    window.addEventListener("resize", handleResize);
    handleResize();

    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  const handleDocumentSubmit = (values) => {
    const formData = new FormData();
    formData.append("landlordId", leaseData.leaseDetails.landlordId);
    formData.append("propId", leaseData.leaseDetails.propId);
    formData.append("type", values.documentType);
    formData.append("files", values.file[0]);
    if (leaseData.leaseDetails.flatId) {
      formData.append("flatId", leaseData.leaseDetails.flatId);
    }
    addDocumentMutate(formData);
  };

  const formatCurrency = (value) => {
    if (!value) return "";
    return new Intl.NumberFormat("en-IN").format(value);
  };

  const formatDisplayDate = (dateString) => {
    if (!dateString) return "--";
    return moment(dateString).format("MMM DD, YYYY");
  };

  const getRentCollectionTypeText = (collectionType) => {
    switch (collectionType) {
      case 1: return "Advance Rent";
      case 2: return "Month-End Rent";
      default: return "--";
    }
  };
  const getOwnershipText = (ownership) => {
    switch (ownership) {
      case 1: return "Owner";
      case 2: return "Co-Owner";
      case 3: return "POA";
      default: return "--";
    }
  };
  const getPropertyTypeText = (propType) => {
    switch (propType) {
      case 1: return "PG";
      case 2: return "Apartment";
      case 3: return "Villa";
      case 4: return "Independent Floor";
      default: return "--";
    }
  };

  return (
    <Container
      style={{
        height: `${height}px`,
        overflow: "auto",
        WebkitOverflowScrolling: "touch",
      }}
    >
      <ModalHeader>
        <h1 className="text-white text-lg font-medium">
          {showUploadForm ? "Upload Document" : "Lease Details"}
        </h1>
        <button onClick={() => {
          setShowUploadForm(false);
          handleClose();
        }}>
          <MdClose color="white" size={24} />
        </button>
      </ModalHeader>

      {showUploadForm ? (
        // Upload Document Form
        <div className="px-6 h-full flex flex-col justify-between">
          <Formik
            initialValues={initialDocumentValues}
            onSubmit={handleDocumentSubmit}
            validationSchema={documentSchema}
          >
            {({ values, setFieldValue, errors, touched }) => (
              <Form>
                <ScrollableContent className="max-h-[calc(100dvh-140px)]">
                  <Wrapper>
                    {/* Document Type */}
                    <InputGroup>
                      <Label htmlFor="documentType">Document Type *</Label>
                      <Select
                        name="documentType"
                        id="documentType"
                        className="w-full px-2"
                        value={values.documentType}
                        onChange={(e) => {
                          setFieldValue("documentType", e.target.value);
                        }}
                        style={{ height: "46px" }}
                        displayEmpty
                      >
                        <MenuItem value="" disabled>
                          Select document type
                        </MenuItem>
                        {documentTypeOptions.map((option) => (
                          <MenuItem key={option.value} value={option.value}>
                            {option.label}
                          </MenuItem>
                        ))}
                      </Select>
                      {errors.documentType && touched.documentType && (
                        <ErrorMessage>{errors.documentType}</ErrorMessage>
                      )}
                    </InputGroup>

                    {/* File Upload */}
                    <InputGroup>
                      <Label htmlFor="file">Document *</Label>
                      <FieldWrapper $select={true}>
                        <Field
                          required
                          name="file"
                          type="text"
                          id="file"
                          autoComplete="off"
                        >
                          {(props) => (
                            <DropZone
                              fields={props.field}
                              setFieldValue={props.form.setFieldValue}
                              componentFor="expense"
                              acceptedFiles="image/*,application/pdf"
                              File={
                                props.field.value
                                  ? [props.field.value]
                                  : null
                              }
                            />
                          )}
                        </Field>
                      </FieldWrapper>
                      {errors.file && touched.file && (
                        <ErrorMessage>{errors.file}</ErrorMessage>
                      )}
                    </InputGroup>
                  </Wrapper>
                </ScrollableContent>
                <ActionSection>
                  <SideCancelBtn
                    type="button"
                    onClick={() => setShowUploadForm(false)}
                  >
                    Cancel
                  </SideCancelBtn>
                  <SubmitBtn type="submit" disabled={addDocumentLoading}>
                    {addDocumentLoading ? "Uploading..." : "Upload"}
                  </SubmitBtn>
                </ActionSection>
              </Form>
            )}
          </Formik>
        </div>
      ) : (
        // Display mode - Show lease details in clean format
        <>
          {/* <ProfileSection className="flex justify-between">
            <UserInfo>
              <span className="font-medium mb-0">
                {leaseData.leaseDetails.propertyName
                  ? (leaseData.leaseDetails.flatName
                    ? `Flat ${leaseData.leaseDetails.flatName} (${leaseData.leaseDetails.propertyName})`
                    : leaseData.leaseDetails.propertyName)
                  : "--"}
              </span>
              <span className="text-sm text-gray-600">
                {leaseData.leaseDetails?.propertyAddress || "--"}
              </span>
            </UserInfo>
            <div className="flex flex-col gap-0">
              <span className='text-gray-500 text-sm'>{'Rent'}</span>
              <span className='text-xl font-semibold text-gray-700'> ₹
                {leaseData.leaseDetails.rent
                  ? formatCurrency(leaseData.leaseDetails.rent)
                  : "--"}</span>
            </div>
          </ProfileSection> */}

          <ModalProfileHeader
            title="Title"
            name={capitalizeFirstLetter(leaseData?.leaseDetails?.propertyName)}
            subtitle={leaseData.leaseDetails?.propertyAddress || "--"}
            amountLabel={"Rent"}
            amount={leaseData?.leaseDetails?.rent || 0}
            image={selectedData?.profilePicture}
            onClose={handleClose}
            showCurrency={true}
          />

          <Content>
            <ScrollableContent>
              <Wrappers>
                <BtnWrapper>
                  <ModalSectionTitle>Landlord Details</ModalSectionTitle>
                  <EditButton
                    title="Edit Details"
                    onClick={() => {
                      // handleClose();
                      setShowEditLeaseModel(true);
                    }}
                  >
                    Edit
                  </EditButton>
                </BtnWrapper>
                <ModalSection>
                  <ModalRow>
                    <FlexCol>
                      <LabelShow>Landlord Name</LabelShow>
                      <ModalRowValue>
                        {leaseData.leaseDetails.landlordName || "--"}
                      </ModalRowValue>
                    </FlexCol>
                    <FlexCol>
                      <LabelShow>Mobile Number</LabelShow>
                      <ModalRowValue>
                        {leaseData.leaseDetails.landlordMobile || "--"}
                      </ModalRowValue>
                    </FlexCol>
                  </ModalRow>
                  {leaseData?.leaseDetails?.flatName &&
                    <ModalRow>
                      <FlexCol>
                        <LabelShow>Flat Name</LabelShow>
                        <ModalRowValue>
                          {leaseData?.leaseDetails?.flatName || "--"}
                        </ModalRowValue>
                      </FlexCol>
                    </ModalRow>
                  }
                </ModalSection>

                <BtnWrapper>
                  <ModalSectionTitle>Rent Details</ModalSectionTitle>
                </BtnWrapper>
                <ModalSection>
                  <ModalRow>
                    <FlexCol>
                      <LabelShow>Security Deposit</LabelShow>
                      <ModalRowValue>
                        ₹
                        {leaseData.leaseDetails.security
                          ? formatCurrency(leaseData.leaseDetails.security)
                          : "--"}
                      </ModalRowValue>
                    </FlexCol>
                    <FlexCol>
                      <LabelShow>Rent Date</LabelShow>
                      <ModalRowValue>
                        {leaseData?.leaseDetails?.rentDate ? formatDisplayDate(leaseData.leaseDetails.rentDate) : "--"}
                      </ModalRowValue>
                    </FlexCol>
                  </ModalRow>
                  <ModalRow>
                    <FlexCol>
                      <LabelShow>Agreement Start</LabelShow>
                      <ModalRowValue>
                        {formatDisplayDate(leaseData.leaseDetails.startDate)}
                      </ModalRowValue>
                    </FlexCol>
                    <FlexCol >
                      <LabelShow>Agreement End</LabelShow>
                      <ModalRowValue>
                        {formatDisplayDate(leaseData.leaseDetails.endDate)}
                      </ModalRowValue>
                    </FlexCol>
                  </ModalRow>
                  {/* <ModalRow>
                    <FlexCol>
                      <LabelShow>Increment Type</LabelShow>
                      <ModalRowValue>
                        {leaseData?.leaseDetails?.incrementType === 1 ? 'Flat Amount' : 'Percentage'}
                      </ModalRowValue>
                    </FlexCol>
                    <FlexCol >
                      <LabelShow>Increment ModalRowValue</LabelShow>
                      <ModalRowValue>
                        {(leaseData?.leaseDetails?.incrementType === 1 ? '₹' : '%') + leaseData.leaseDetails.incrementValue}
                      </ModalRowValue>
                    </FlexCol>
                  </ModalRow> */}
                  <ModalRow>
                    <FlexCol>
                      <LabelShow>Notice Period</LabelShow>
                      <ModalRowValue>
                        {leaseData.leaseDetails.notice
                          ? `${leaseData.leaseDetails.notice} month${leaseData.leaseDetails.notice > 1 ? "s" : ""
                          }`
                          : "--"}
                      </ModalRowValue>
                    </FlexCol>
                    <FlexCol >
                      <LabelShow>Rent Increment</LabelShow>
                      <ModalRowValue>
                        {leaseData.leaseDetails.incrementType === 2 ? leaseData.leaseDetails.incrementValue + '%' : leaseData.leaseDetails.incrementType === 1 ? '₹' + leaseData.leaseDetails.incrementValue : "-"}
                      </ModalRowValue>
                    </FlexCol>
                  </ModalRow>

                  <ModalRow>
                    <FlexCol>
                      <LabelShow>Increment Month</LabelShow>
                      <ModalRowValue>
                        {leaseData.leaseDetails.incrementMonth
                          ? `${leaseData.leaseDetails.incrementMonth} month${leaseData.leaseDetails.incrementMonth > 1 ? "s" : ""
                          }`
                          : "--"}
                      </ModalRowValue>
                    </FlexCol>
                    <FlexCol >
                      <LabelShow>Lock In Period</LabelShow>
                      <ModalRowValue>
                        {leaseData.leaseDetails.lockInPeriod
                          ? `${leaseData.leaseDetails.lockInPeriod} month${leaseData.leaseDetails.lockInPeriod > 1 ? "s" : ""
                          }`
                          : "--"}
                      </ModalRowValue>
                    </FlexCol>
                  </ModalRow>
                  <ModalRow>
                    <FlexCol >
                      <LabelShow>Ownership</LabelShow>
                      <ModalRowValue>
                        {getOwnershipText(leaseData.leaseDetails.ownershipType)}
                      </ModalRowValue>
                    </FlexCol>

                    <FlexCol >
                      <LabelShow>Property Type</LabelShow>
                      <ModalRowValue>
                        {getPropertyTypeText(leaseData.leaseDetails.propertyType)}
                      </ModalRowValue>
                    </FlexCol>
                  </ModalRow>

                  <ModalRow>
                    <FlexCol >
                      <LabelShow>Rent Collection Type</LabelShow>
                      <ModalRowValue>
                        {getRentCollectionTypeText(leaseData.leaseDetails.rentCollectionType)}
                      </ModalRowValue>
                    </FlexCol>

                    <FlexCol >
                      <LabelShow>Created On</LabelShow>
                      <ModalRowValue>
                        {formatDisplayDate(leaseData.leaseDetails.createdAt)}
                      </ModalRowValue>
                    </FlexCol>
                  </ModalRow>
                </ModalSection>

                <BtnWrapper>
                  <ModalSectionTitle>Manage Payment Details</ModalSectionTitle>
                  {fromPage === "list" &&
                    <EditButton
                      title="Manage Details"
                      onClick={() => {
                        handleClose();
                        setShowManagePaymentModel(true);
                      }}
                    >
                      Manage
                    </EditButton>}
                </BtnWrapper>
                <ModalSection>
                  <ModalRow>
                    <FlexCol>
                      <LabelShow>Bank Name</LabelShow>
                      <ModalRowValue>
                        {leaseData?.landlordAccount?.bankName || "--"}
                      </ModalRowValue>
                    </FlexCol>
                    <FlexCol>
                      <LabelShow>Account Holder</LabelShow>
                      <ModalRowValue>
                        {leaseData?.landlordAccount?.holderName || "--"}
                      </ModalRowValue>
                    </FlexCol>
                  </ModalRow>
                  <ModalRow>
                    <FlexCol>
                      <LabelShow>Account Number</LabelShow>
                      <ModalRowValue>
                        {leaseData?.landlordAccount?.accountNum || "--"}
                      </ModalRowValue>
                    </FlexCol>
                    <FlexCol>
                      <LabelShow>IFSC Code</LabelShow>
                      <ModalRowValue>
                        {leaseData?.landlordAccount?.ifsc || "--"}
                      </ModalRowValue>
                    </FlexCol>
                  </ModalRow>
                  <ModalRow>
                    <FlexCol>
                      <LabelShow>Merchant Id</LabelShow>
                      <ModalRowValue>
                        {leaseData?.landlordAccount?.mId || "--"}
                      </ModalRowValue>
                    </FlexCol>
                    {/* <FlexCol>
                      <LabelShow>Gateway</LabelShow>
                      <ModalRowValue>
                        {leaseData?.landlordAccount?.gateway || "--"}
                      </ModalRowValue>
                    </FlexCol> */}
                  </ModalRow>
                </ModalSection>

                {/* Document ModalSection */}
                <BtnWrapper>
                  <ModalSectionTitle>Documents</ModalSectionTitle>
                  {/* {!hasLeaseDocs && ( */}
                  <EditButton
                    type="button"
                    onClick={() => setShowUploadForm(true)}
                  >
                    Upload Document
                  </EditButton>
                  {/* )} */}
                </BtnWrapper>
                <ModalSection>
                  {hasLeaseDocs ? (
                    <div >
                      {(documentData?.data?.docs || leaseData.docs).map((doc, index) => (
                        <div
                          key={index}
                          className="flex items-center justify-between p-2"
                        >
                          <span className="text-gray-700">
                            {doc.title || `Document ${index + 1}`}
                          </span>
                          <a
                            href={doc.value}
                            target="_blank"
                            rel="noopener noreferrer"
                            className="text-blue-500 underline text-sm"
                          >
                            View
                          </a>
                        </div>
                      ))}
                    </div>
                  ) : (
                    <div className="text-center py-4">
                      <p className="text-gray-500">No documents uploaded</p>
                    </div>
                  )}
                </ModalSection>
              </Wrappers>
            </ScrollableContent>
          </Content>
        </>
      )
      }
    </Container>
  );
};

// Styled components matching ViewDetails
const Header = tw.div`flex items-center justify-between bg-[#0078BD] py-4 px-4`;
const Wrappers = tw.div`grid gap-2 my-0`;
const Container = tw.div`bg-white w-full h-full min-h-[100vh] flex flex-col`;
const Content = tw.div`p-4 flex flex-col gap-4`;
const Title = tw.h1`text-lg md:text-xl font-medium text-center text-white`;
//const ModalSection = tw.div`border border-gray-200 p-2 rounded-lg mb-3`;
//const ModalSectionTitle = tw.h2`text-base font-medium text-gray-600 flex justify-between items-center`;
//const ModalRow = tw.div`grid grid-cols-2 py-1 md:p-1`;
const LabelShow = tw.label`text-sm text-gray-400 font-normal`;
//const ModalRowValue = tw.span`text-gray-600 text-md`;
const BtnWrapper = tw.div`w-full flex items-center justify-between`;
const FlexCol = tw.div`flex flex-col gap-0.5`;
const UserInfo = tw.div`flex flex-col`;
const ProfileSection = tw.div`flex items-center gap-3 bg-gray-100 px-4 p-4`;
const ErrorMessage = tw.div`text-red-500 text-xs mt-1`;
const UploadButton = tw.button`text-sm text-primary-color underline rounded `;
const FieldWrapper = tw.div`w-full`;
const CalenderFieldWrappers = tw.div`pl-2 rounded-md w-full flex items-center border border-gray-300 h-11`;
//const EditButton = tw.button` text-sm px-1 py-0.5 items-center flex justify-between text-primary-color underline`;

export default ViewLeaseDetails;
